import jwtDecode from 'jwt-decode';

export function getAccessToken() {
  return localStorage.getItem('accessToken');
}

export function setAccessToken(token) {
  localStorage.setItem('accessToken', token);
}

export function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

export function setRefreshToken(token) {
  localStorage.setItem('refreshToken', token);
}

export function removeAllTokens() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
}

export const getDecodedUserId = () => {
  const token = getAccessToken();

  if (token) {
    try {
      const decoded = jwtDecode(token);
      return decoded.uid;
    } catch (err) {
      console.log(`Decoding token error: ${err}`);
    }
  }
  return '';
};

export const getDecodedUserName = () => {
  const token = getAccessToken();

  if (token) {
    try {
      const decoded = jwtDecode(token);
      return decoded.unm;
    } catch (err) {
      console.log(`Decoding token error: ${err}`);
    }
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/utils/auth.js